export function isBranchUser(role) {
  return ['branch_admin', 'branch_user'].includes(role)
}
